import { Injectable } from '@angular/core';
import {Observable, BehaviorSubject, from} from 'rxjs';
import {tap, mergeMap, concatMap} from 'rxjs/operators';
import { SubscriptionModel } from "../models/Subscriptions";
import {environment} from '../../environments/environment';
import {HttpHeaders} from '@angular/common/http';
import {HttpService} from './http.service';

@Injectable()
export class SubscriptionService {

    reportSubscriptions$: BehaviorSubject<SubscriptionModel[]> = new BehaviorSubject([]);
    lastSubscriptions: SubscriptionModel[];

    constructor(
        private httpService: HttpService,
    ) {
        this.reportSubscriptions$.subscribe(subscriptions => this.lastSubscriptions = subscriptions);
     }


    getReportSubscriptions(): Observable<SubscriptionModel[]> {
        return this.httpService.get<SubscriptionModel[]>(
            environment.apiCommonV3BaseUrl + '/scm-report-subscriptions',
            { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
        ).pipe(
            tap(result => {
                this.reportSubscriptions$.next(result);
            })
        );
    }

    addReportSubscription(subscription: SubscriptionModel): Observable<SubscriptionModel[]>  {
        return this.httpService.post(environment.apiCommonV3BaseUrl + '/scm-report-subscriptions', subscription).pipe(
            mergeMap(() => this.getReportSubscriptions())
        );
    }


    addReportSubscriptions(subscriptions: SubscriptionModel[]): Observable<SubscriptionModel[]> {
        return from(subscriptions).pipe(
            mergeMap(subscription =>
                this.httpService.post(environment.apiCommonV3BaseUrl + '/scm-report-subscriptions', subscription)
            ),
            mergeMap(() => this.getReportSubscriptions())
        );
    }

    updateReportSubscription(subscription: Partial<SubscriptionModel>, id: number) {
        return this.httpService.patch(`${environment.apiCommonV3BaseUrl}/scm-report-subscriptions/${id}`, subscription).pipe(
            mergeMap(() => this.getReportSubscriptions())
        );
    }

    deleteReportSubscription(id: number) {
        return this.httpService.delete(`${environment.apiCommonV3BaseUrl}/scm-report-subscriptions/${id}`).pipe(
            concatMap(() => this.getReportSubscriptions())
        );
    }
}
